const $gfieldRadio = $('.gfield_radio');

if ($gfieldRadio.length !== 0) {
	$gfieldRadio.each(function() {
		const $ul = $(this);
		const $li = $ul.children('li');
		$li.each(function() {
			const $label = $(this).find('label');
			const text = $label.text();
			const $span = $(`<span>${text}</span>`);
			$label
				.text('')
				.append($span);
		});
	});
}


const $gform1 = $('#gform_1');
const $submit = $('#gform_submit_button_1');
$gform1.on('submit', function(e) {
	if (typeof ga === 'function') {
		e.preventDefault();
		$submit[0].disabled = true;
		ga('send', 'event', {
			eventCategory: 'Event',
			eventAction: 'Button-click',
			eventLabel: 'Contact',
			hitCallback: function() {
				$gform1[0].submit();
			}
		});
	}
});